export default function () {
  return [
    {
      title: 'Produkty',
      to: '/products',
      htmlBefore: '<i class="material-icons">fastfood</i>',
      htmlAfter: ''
    },
    {
      title: 'Składniki',
      to: '/ingredients',
      htmlBefore: '<i class="material-icons">category</i>',
      htmlAfter: ''
    },
    {
      title: 'Opakowania',
      to: '/packages',
      htmlBefore: '<i class="material-icons">inbox</i>',
      htmlAfter: ''
    },
    {
      title: 'Archiwum',
      to: '/archive',
      htmlBefore: '<i class="material-icons">archive</i>',
      htmlAfter: ''
    },
    {
      title: 'Twoje konto',
      to: '/account',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: ''
    },
    {
      title: 'Panel administratora',
      to: '/admin',
      htmlBefore: '<i class="material-icons">settings</i>',
      htmlAfter: ''
    },
    {
      title: 'Wyloguj się',
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/logout'
    }
  ];
}
